import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    View,
    FlatList,
    ScrollView,
    TouchableOpacity,
    KeyboardAvoidingView,
    ActivityIndicator,
} from "react-native";

import {moderateScale} from '../../../../../tools/Scaling';


import HMActionBar from "../../../../../customviews/HMActionBar";


import i18n from '../../../../../I18n/i18n.js';

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../../../customviews/DialogLoadingCustomize";
import {Tools} from "../../../../../tools/Tools";
import HMTextView from "../../../../../customviews/HMTextView";
import Colors from "../../../../../tools/Colors";

import {typeExport} from "../../../../../redux/store/type";

import HMLoading from "../../../../../customviews/HMLoading";

import DialogConnectionCustomize from "../../../../../customviews/DialogConnectionCustomize";
import store from "../../../../../redux/store";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import HMAlert from "../../../../../customviews/HMAlert";

let container = null;

import {connect} from "react-redux";
import HMIcon from "../../../../../customviews/HMIcon";
import axios from "axios";
import PathFile from "../../../../../assets/PathFile";
import BigList from "react-native-big-list";

class UnitsMyStateScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        global.G_DataUnits = false;
        let _params = props.route.params;


        let columnCount = 1;
        let viewportWidth = 1;
        let viewportHeight = 1;

        if (Platform.OS === "web") {

            viewportWidth = document.documentElement.clientWidth;
            viewportHeight = document.documentElement.clientHeight;

            columnCount = viewportWidth > 900 ? 4 : 2;

        }
        let checkSmall = Platform.OS === "web" && viewportWidth <= 900;

        // switch (Platform.OS) {
        //
        //     case "android":
        //         firebase = require("react-native-firebase")
        //
        //         break;
        //     default:
        //
        // }
        // if (Platform.OS === "android") {
        //      firebase = require("react-native-firebase")
        //
        // }


        let arraySelectCheckBoxArea = []
        if (_params && _params.itemExtra) {
            arraySelectCheckBoxArea = _params.itemExtra.filter(function (item) {

                return item.selected == 1;
            });

        }
        this.state = {
            columnCount: columnCount,
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            alaki: false,
            viewportWidth: Platform.OS === "web" ? viewportWidth : typeExport._WIDTH,
            viewportHeight: viewportHeight,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            arraySelectCheckBoxArea: arraySelectCheckBoxArea,
            listUnit: _params && _params.itemExtra ? _params.itemExtra : [],
            nameInputText: _params.name,
            checkSmall: false,

        };


    }


    componentDidMount() {
        this.props.navigation.addListener('focus', () => {
                if (global.G_DataUnits) {
                    global.G_DataUnits = false;
                    this.getDataUnits();

                }
                this.setState({
                    alaki: !this.state.alaki,
                })
                container = this;
            }
        )

        this.props.navigation.addListener('blur', () => {
        })
        if (!global.G_DataUnits)
            this.getDataUnits();

        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.documentElement.clientWidth;
                let viewportHeight = document.documentElement.clientHeight;


                // container.setState({
                //         viewportWidth: viewportWidth,
                //         viewportHeight: viewportHeight,
                //         itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                //         columnCount: viewportWidth > 600 ? 4 : 2,
                //     },
                // );

                let checkSmall = (viewportWidth <= 900);
                if (!checkSmall && container.state.smallView) {
                    container.setState({
                            smallView: false,
                            viewportWidth: viewportWidth,
                            viewportHeight: viewportHeight,
                            itemWidth: viewportWidth > 900 ? 900 : viewportWidth,
                            columnCount: viewportWidth > 900 ? 4 : 2,
                            // itemWidth: viewportWidth > 900 ? 480 : viewportWidth,
                            // columnCount: viewportWidth > 1000 ? 2 : 1,
                        },
                    )
                }
                else if (checkSmall && !container.state.smallView) {
                    container.setState({
                            smallView: true,
                            viewportWidth: viewportWidth,
                            viewportHeight: viewportHeight,
                            itemWidth: viewportWidth > 900 ? 900 : viewportWidth,
                            columnCount: viewportWidth > 900 ? 4 : 2,
                            // itemWidth: viewportWidth > 900 ? 480 : viewportWidth,
                            // columnCount: viewportWidth > 1000 ? 2 : 1,
                        },
                    )
                }

            })
        this.unsubscribeFromNotificationListener = Tools.receiveonOnNotification(this.changeMenu)

    }

    changeMenu() {
        container.setState({alaki: !container.state.alaki})
    }

    getData() {
        let {mobile, password} = this.state;

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": typeExport._GetCalendar,
            "lang": i18n.locale,

            //    "username": mobile,
            //  "password": password,
            //
            // "username": Tools.persianToEnglish(mobile),
            // "password": Tools.persianToEnglish(password),
            // "token_fb": this.props.DataSplashScreen.token_fb,
        };
        paramss = Tools.addAllParams(paramss);
        this.props.callService(
            typeExport.urlApplyScreen,
            paramss,
            typeExport.TypeGetApplyScreen,
            "POST",
            this.state
        );

    }

    componentWillUnmount() {

        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener?.();
        }
    }

    render() {
        let {viewportWidth, viewportHeight} = this.state;
        let list = this.props.route.params ? this.props.route.params.list : null;
        let _params = this.props.route.params;
        let item = _params.item;
        const renderItem = ({item, index}) => {
            let mode = true;
            // if (Platform.OS !== "web") {
            //     item = type.item;
            //     index = type.index;
            // }
            //if (index === 0)
            return <View style={{
                flexDirection: "row",
                flex: 1,

                //width: moderateScale(100),
                margin: moderateScale(4),
                alignItems: "center",
                borderRadius: moderateScale(4),
                backgroundColor: Colors.white,
            }}>
                <HMIcon

                    //source={require('../../../../../assets/img/success.png')}
                    //source={PathFile.image.background}
                    //svg={PathFile.svg.add}
                    type={"svg"}
                    source={PathFile.svg.edit}
                    height={moderateScale(22)}
                    width={moderateScale(22)}

                    name={"add-circle-sharp"}
                    style={{
                        // fontSize: moderateScale(20),
                        // color: Colors.blue,
                        // marginHorizontal: moderateScale(4),
                        marginRight: moderateScale(4),
                        marginLeft: moderateScale(4),
                        //  marginTop: moderateScale(3)
                    }}
                    onPress={() => {
                        NavigationService.navigateKeyDynamic("SettingMyStateScreen", {
                            // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                            data: item,
                            item: item,
                            itemOriginal: item,
                            type: "requestMahalehMa"
                        })
                    }}
                />
                <HMTextView
                    text={item.name} type={"bold"}
                    style={{
                        color: "#113956",
                        //marginHorizontal: moderateScale(6),
                        fontSize: moderateScale(14),
                        textAlign: 'center',

                    }}
                    styleRoot={{
                        flex: 1,
                        flexWrap: 'wrap',

                    }}
                />


            </View>
        }
        //  let item = _params && _params.item ? JSON.parse(_params.item) : null;
        return (


            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        {/*  <HMGradient
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                left: 0,
                                bottom: 0,
                                flex: 1,
                                // alignItems: 'center'
                            }}
                            color1={"#4cee1c"}
                            color2={"#0012ee"}

                            x1="0%" y1="0%" x2="0%" y2="100%"

                        />*/}

                        <HMActionBar
                            //  menu={!checkLogin}
                            menu={typeExport._NameApp != "MahalemaArak"}
                            // menu
                            back={typeExport._NameApp != "MahalemaArak"}
                            //  exit={checkLogin && !type}
                            exit={typeExport._NameApp == "MahalemaArak"}
                            funcExit={() => {

                                HMAlert(
                                    i18n.t('constant.message'),
                                    "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                                    [
                                        // {text: 'Ask me later', onPress: () => {}},
                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                        {
                                            text: i18n.t('constant.ok'), onPress: () => {
                                                AsyngStorageClass.removeToken(typeExport._Shahrdar);
                                                NavigationService.resetTo('LoginStackScreen');

                                            }
                                        },
                                    ],
                                    {cancelable: true}
                                )


                                // Tools.remove()
                                // NavigationService.resetTo("SplashScreen")
                            }}
                            props={this.props} statusBarTransparent
                            //  text={i18n.t('Apply.title')}
                            // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? this.props.DataSplashScreen.user.name + " " + this.props.DataSplashScreen.user.family : null}
                            text={item ? (item.name ? item.name : (item.title ? item.title : '')) : null}
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}
                            // funcExit={checkLogin ? () => {
                            //
                            //     HMAlert(
                            //         i18n.t('constant.message'),
                            //         "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                            //         [
                            //             // {text: 'Ask me later', onPress: () => {}},
                            //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            //             {
                            //                 text: i18n.t('constant.ok'), onPress: () => {
                            //                     AsyngStorageClass.removeToken(typeExport._Shahrdar);
                            //                 }
                            //             },
                            //         ],
                            //         {cancelable: true}
                            //     )
                            //
                            //
                            //     // Tools.remove()
                            //     // NavigationService.resetTo("SplashScreen")
                            // } : null}
                            styleText={[{marginStart: moderateScale(48)}]}

                        />

                        {
                            (!this.props.DataSplashScreen.NoInternetDialogShahrdar) && (!this.props.DataSplashScreen.isLoadingShahrdar) ?
                                null
                                :
                                <View
                                    style={{
                                        width: "100%",
                                        //  flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: this.props.DataSplashScreen.NoInternetDialogShahrdar ? Colors.red : Colors.white,
                                        alignSelf: 'center',
                                        padding: moderateScale(6)
                                    }}
                                >
                                    {this.props.DataSplashScreen.NoInternetDialogShahrdar ?
                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={"bold"}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: "center",
                                                        color: Colors.white,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={"خطایی رخ داده مجددا تلاش نمایید"}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.getDataServerSplash()

                                                }}
                                                style={{
                                                    // flex: .33,
                                                    // width: '92%',
                                                    // height: moderateScale(28),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.yellow,
                                                    borderRadius: moderateScale(6),
                                                    marginHorizontal: moderateScale(2),
                                                    paddingHorizontal: moderateScale(4),
                                                    paddingVertical: moderateScale(2),


                                                }}>

                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={i18n.t('constant.Update')}
                                                    //  text={"ثبت و بستن تیکت"}
                                                    type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(10),
                                                        marginVertical: moderateScale(2),
                                                        //     marginHorizontal: moderateScale(4),
                                                        color: Colors.white
                                                    }}/>
                                            </TouchableOpacity>

                                        </View>
                                        :

                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={"bold"}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={i18n.t('constant.Update')}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <ActivityIndicator color={Colors.colorPrimary} size={"small"}/>

                                        </View>
                                    }
                                </View>
                        }


                        <View
                            style={{
                                flex: 1,
                                // alignItems: 'center'
                            }}
                        >

                            {
                                this.props.results == null && this.props.isLoading ?
                                    <HMLoading/>

                                    :
                                    <View
                                        style={{
                                            flex: 1
                                        }}>
                                        <BigList

                                            renderItem={renderItem}


                                            ref={(ref) => {
                                                this.list1 = ref && ref.flatListRef?.current;
                                            }}
                                            keyExtractor={(item, index) => index.toString()}
                                            // keyExtractor={(item, index) => index.toString() + (Unit.top_subject_groups?.length)}
                                            extraData={{
                                                alaki: this.state.alaki,
                                            }}
                                            data={this.state.listSearch ? this.state.listSearch : []}
                                            numColumns={this.state.columnCount}
                                            key={this.state.columnCount}

                                        />
                                    </View>


                            }

                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                            }
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>

        );
    }


    onPressSelectCheckBox(item, name, check) {

        let idx = container.state["arraySelectCheckBox" + name].findIndex(obj => obj.id === item.id);
        let arr = container.state["arraySelectCheckBox" + name];

        if (idx !== -1) {
            arr.splice(idx, 1)

            // container.setState({
            //         arraySelected: arr
            //     },
            //
            //     () => {
            //         //  container.state.arraySelected.slice(container.state.indexFilter, 1)
            //         container.state.arraySelected.push({
            //             index: container.state.indexFilter,
            //             data: data,
            //             id: data.id,
            //             value: data.name,
            //             type: container.state.typeFilter
            //         })
            //     }
            // )

        } else {
            container.state["arraySelectCheckBox" + name].push(item)
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }


        container.setState({
                //   ['indexSelectCheckBox' + name]: check ? null : (item.id ? item.id : item.value)
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value),
            },
            () => {
            })
    }

    goScreen(route, item, position) {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        container.setState({isLoading: false})
        NavigationService.navigateParams(route, {
            position: JSON.stringify(Tools.cloneAsObject(position)),
            //   position: JSON.stringify(position),
            //  position:position,
            typeComponent: checkLogin ? "Operation" : null,
            item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : JSON.stringify(item),
            data: JSON.stringify(item),
            type: route
        })
    }

    stateError() {
        container.setState({
            locationEnabled: false,
            isLoading: false,
        }, () => {
        })
    }

    getDataUnits(func) {

        let {item} = this.props.route.params;
        if (item && item.id) {
            return;
        }
        let formData = new FormData();
        formData.append('_operation', typeExport._Shahrdar);
        formData.append('mode', "GetUnit");
        formData.append('lang', i18n.locale);
        formData.append('token', container.props.DataSplashScreen.token);
        formData.append('tokenLaravel', container.props.DataSplashScreen.tokenLaravel);
        Tools.addAllFormData(formData, true);

        if (item && item.id) {
            formData.append('with_units', 1);
            formData.append('ids[]', [item.id]);
        }
        //   formData.append('ids[]', JSON.stringify(`[${item.id}]`));

        //  formData.append('record', itemParams.RequestID);
        container.requestServer(
            formData, (item) => {
                let result = item && item.units && item.units.length > 0 ? item.units : [];
                container.setState({

                    listUnit: result,
                    listSearch: result,
                    // List: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                }, () => {

                    func ? func() : null
                })
            }, null
        );
    }


    requestServer(formData, func, noLoading) {

        container.setState({
            //ShowImage:true
            isLoading: !noLoading,
            NoInternetDialog: false,
            results: null


        })


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);


        axios({
            method: 'post',
            url: typeExport._baseUrlSainaShahrdar,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    func ? func(data.result) : null
                    // container.getDataServerSplash()
                }
                else {
                    /*    HMAlert(
                            i18n.t('constant.message'),
                            data.message,
                            [
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {

                                    }


                                },

                            ],
                            {cancelable: true}
                        )*/
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.success,

                })
            }).catch((e) => {
            console.log('error', e)

            // HMAlert(
            //     i18n.t('constant.message'),
            //     "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
            //     [
            //         {
            //             text: i18n.t('constant.ok'), onPress: () => {
            //
            //             }
            //
            //
            //         },
            //
            //     ],
            //     {cancelable: true}
            // )
            container.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
        })
    }

    SearchFilterFunction(data, text) {


        const newData = data.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.subjects_tks_subject.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(Tools.convertToEnglishNumberWord(textData)) > -1
        })

        this.setState({
                listSearch: text && text.length > 0 ? newData : [],

            },
            () => {

            })
    }
}


const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashGetAllData,
        token: state.reducerSplashGetAllData.token,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(UnitsMyStateScreen);
